<div>
  <button class='close' [hidden]='!hasClose' (click)='dismiss()'><i class='mt-cancel'></i></button>
  <h1>{{title}}</h1>
  <div class='message' [hidden]='!message' [innerHTML]='message'></div>
  <div class='buttons' [ngClass]='{"vertical": buttonsVertical}' [hidden]='buttons.length === 0'>
    <ng-container *ngFor='let button of buttons'>
      <button class='{{button.type}}' (click)='select(button)'>{{button.name}}</button>
    </ng-container>
  </div>
</div>
